<phms-case-context-record-grid
  [appTerminologyIdentity]="sectionUsage.heading"
  [heading]="sectionText.heading()"
  [records]="records"
  [state]="state"
  [stateCopy]="{
    loadingText: 'Loading criminal history…',
    emptyText: 'No criminal history on file.',
    errorText: 'Criminal history is temporarily unavailable.',
  }"
  itemLabelSingular="history record"
  itemLabelPlural="history records"
  [columnDefs]="columnDefs"
></phms-case-context-record-grid>
